import React, { Fragment } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import {buttonStyle, colors} from './caseStylesRefactor'

const styles = {
  header: {
    backgroundColor: colors.panel,
    borderBottom: `1px solid ${colors.border}`,
  },
  altHeader: {
    backgroundColor: colors.cyan,
    borderBottom: `1px solid ${colors.border}`,
  },
  title: {
    color: colors.text,
    fontSize: '1.2em',
    fontWeight: '500',
    margin: 0,
  },
  altTitle: {
    color: colors.panelDark,
    fontSize: '1.2em',
    fontWeight: '500',
    margin: 0,
  },
  body: {
    backgroundColor: colors.panelDark,
    color: colors.text,
    fontSize: '1em',
    fontWeight: '400',
  },
  altBody: {
    backgroundColor: colors.panel,
    color: colors.text,
    fontSize: '1em',
    fontWeight: '400',
  },
  footer: {
    backgroundColor: colors.panelDark,
    borderTop: `1px solid ${colors.border}`,
  },
  altFooter: {
    backgroundColor: colors.panel,
    borderTop: `1px solid ${colors.border}`,
  },
}

const CaseDetailModalRefactor = (props) => {
  return(
    <div>
      {props.altHeader ?
        <Fragment>
          {props.altHeader} 
        </Fragment> :
        <Modal.Header style={styles.header}>
          <h4 style={styles.title}>{props.title} {props.id}</h4>
        </Modal.Header>
      }
      
      <Modal.Body style={styles.body}>
        {props.children}
        <Modal.Footer style={styles.footer}>
          <Button className='case-detail-modal-action case-detail-modal-close-action' style={buttonStyle} onClick={() => props.closeFunction()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </div>
  )
}

export default CaseDetailModalRefactor
